// extracted by mini-css-extract-plugin
export var backdropBlur = "_e4-0";
export var contentCard = "_e4-5";
export var frame = "_e4-2";
export var image = "_e4-4";
export var imagePane = "_e4-3";
export var modal = "_e4-1";